import axiosLC from "services";

export const getAccessToken = async () => {
  const resultLogin = await axiosLC.post("/oauth2/token", {
    client_id: process.env.REACT_APP_API_KEY_ID ?? "",
    client_secret: process.env.REACT_APP_API_KEY ?? "",
  });
  const token = resultLogin.data.access_token;
  return token;
};
